import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\RunCompanyPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/RunCompanyPaymentSyncController.php
* @route '/api/company/{company}/chift/payment-sync/run'
*/
const RunCompanyPaymentSyncController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RunCompanyPaymentSyncController.url(args, options),
    method: 'post',
})

RunCompanyPaymentSyncController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/chift/payment-sync/run',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\RunCompanyPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/RunCompanyPaymentSyncController.php
* @route '/api/company/{company}/chift/payment-sync/run'
*/
RunCompanyPaymentSyncController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return RunCompanyPaymentSyncController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\RunCompanyPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/RunCompanyPaymentSyncController.php
* @route '/api/company/{company}/chift/payment-sync/run'
*/
RunCompanyPaymentSyncController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RunCompanyPaymentSyncController.url(args, options),
    method: 'post',
})

export default RunCompanyPaymentSyncController